import { Linking, Platform } from "react-native"

export interface OpenWebsiteDialogState {
  isVisible: boolean
  url: string | null
}

class OpenWebsiteDialogManager {
  private listeners: Array<(state: OpenWebsiteDialogState) => void> = []
  private currentState: OpenWebsiteDialogState = { isVisible: false, url: null }

  subscribe(listener: (state: OpenWebsiteDialogState) => void) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener)
    }
  }

  show(url: string) {
    this.currentState = { isVisible: true, url }
    this.notifyListeners()
  }

  hide() {
    this.currentState = { isVisible: false, url: null }
    this.notifyListeners()
  }

  getCurrentState() {
    return this.currentState
  }

  private notifyListeners() {
    this.listeners.forEach((listener) => listener(this.currentState))
  }
}

export const openWebsiteDialogManager = new OpenWebsiteDialogManager()

/** Open a URL in a new browser tab (web) or via the system linker (native). */
export function openWebsiteUrlInNewTab(url: string): void {
  if (!url) return
  if (Platform.OS === "web" && typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer")
  } else {
    Linking.openURL(url)
  }
}

/** Web only: prompt the user to open a website in a new tab instead of embedding it. */
export function promptOpenWebsiteInNewTab(url: string) {
  if (Platform.OS !== "web" || !url) return
  openWebsiteDialogManager.show(url)
}
